import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ALL_CONTACTS_TAKE } from "../../const/const";
import { IPagination } from "../../interfaces/IPagination/IPagination";

const initialState: IPagination = {
  skip: 0,
  take: ALL_CONTACTS_TAKE,
  firstLetter: "",
  searchPattern: "",
  currentPage: 1,
};

const paginationSlice = createSlice({
  name: "pagination",
  initialState: initialState,
  reducers: {
    setPagination(state, action: PayloadAction<IPagination>) {
      Object.assign(state, action.payload);
    },
  },
});

export const { setPagination } = paginationSlice.actions;
export default paginationSlice.reducer;
